import { Rocket, PanelLeft } from 'lucide-react';
import { cn } from '@reflex/ui/lib/utils';
import { Button } from '@reflex/ui/components/ui/button';
import { PanelHeader } from '@reflex/ui/components/layout/PanelHeader';
import { PanelTitle, PageDescription } from '@reflex/ui/components/layout/Typography';

interface AgentDashboardProps {
  onToggleSidebar?: () => void;
  onLaunchAgent: () => void;
  /**
   * Show the sidebar toggle at every viewport. Default: mobile only
   * (`md:hidden`). The sessions dock sets this so the stream pane can
   * collapse the dock, which is the shell's nav panel on desktop.
   */
  sidebarToggleAlwaysVisible?: boolean;
}

export function AgentDashboard({
  onToggleSidebar,
  onLaunchAgent,
  sidebarToggleAlwaysVisible,
}: AgentDashboardProps) {
  return (
    <div className="flex h-full flex-col">
      <PanelHeader
        left={
          onToggleSidebar ? (
            <Button
              variant="ghost"
              size="icon-sm"
              className={cn('shrink-0', !sidebarToggleAlwaysVisible && 'md:hidden')}
              onClick={onToggleSidebar}
              aria-label={sidebarToggleAlwaysVisible ? 'Toggle sidebar' : 'Open sidebar'}
            >
              <PanelLeft className="h-4 w-4" />
            </Button>
          ) : undefined
        }
      />

      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-4 text-center">
        <Button
          size="icon-lg"
          onClick={onLaunchAgent}
          aria-label="Launch an agent"
          className="size-14 rounded-2xl hover:bg-accent hover:text-accent-foreground"
        >
          <Rocket className="size-7" />
        </Button>
        <div>
          <PanelTitle as="h2">
            <button
              type="button"
              onClick={onLaunchAgent}
              className="cursor-pointer rounded-sm underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              Launch an agent
            </button>
          </PanelTitle>
          <PageDescription className="max-w-sm">
            Describe a task and let an agent handle it, from code changes to debugging to running
            commands.
          </PageDescription>
        </div>
      </div>
    </div>
  );
}
